import React, { useState, useEffect } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import './LoginScreen.css';
import { useSignIn } from '../../api/user';

const LoginScreen = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const { mutate: signIn, isLoading: isSigningIn, error: signInError } = useSignIn();

  useEffect(() => {
    document.title = 'Free Table Admin';
    const favicon = document.querySelector("link[rel~='icon']");
    if (!favicon) {
      const link = document.createElement('link');
      link.rel = 'icon';
      link.href = 'https://qglldlnkkypojvppmqzs.supabase.co/storage/v1/object/public/restoranisliki/favicon.png';
      document.head.appendChild(link);
    } else {
      favicon.href = 'https://qglldlnkkypojvppmqzs.supabase.co/storage/v1/object/public/restoranisliki/favicon.png';
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    signIn(
      { email, password },
      {
        onSuccess: () => {
          window.location.href = '/floor-plan';
        },
        onError: (error) => {
        },
      }
    );
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h2>
          <img 
            src='https://qglldlnkkypojvppmqzs.supabase.co/storage/v1/object/public/restoranisliki//FREE%20TABLEwhiteside.png' 
            width={"100%"} 
            alt="Free Table Logo"
          />
        </h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <div style={{ position: 'relative' }}>
              <input
                type={showPassword ? 'text' : 'password'}
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <button
                type="button"
                onClick={togglePasswordVisibility}
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  padding: '0 10px'
                }}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
          </div>
          {signInError && <p className="error">{"Погрешен email или password"}</p>}
          <button type="submit" disabled={isSigningIn}>
            {isSigningIn ? 'Се најавува....' : 'Најави се'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginScreen;